import { Color } from 'three';

var SobelEdgeShader = {
    uniforms: {
        "tDiffuse": { value: null },
        "resolution": { value: null },
        //"isWithGaussianBlur": {value: 1.0},
        "edgeThreshold": { value: 0.5 },
        "edgeColor": { value: new Color(0, 0, 0) },
        //"colorFactor": { value: 1 },
    },

    vertexShader: `
        varying vec2 vUv;

        void main() {
            vUv = uv;
            gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
        }
    `,

    fragmentShader:`
        uniform sampler2D tDiffuse;
        uniform float colorFactor;
        uniform vec2 resolution;
        //uniform float isWithGaussianBlur;
        uniform float edgeThreshold;
        uniform vec3 edgeColor;

        varying vec2 vUv;
        const vec2 gauss_filter[7] = vec2[7]( 
            vec2(-3.0,   0.015625),
            vec2(-2.0,   0.09375),
            vec2(-1.0,   0.234375),
            vec2(0.0,    0.3125),
            vec2(1.0,    0.234375),
            vec2(2.0,    0.09375),
            vec2(3.0,    0.015625));


        float gray(vec2 uv) {
            vec4 texel = texture2D(tDiffuse, uv);
            float gray = 0.21 * texel.r + 0.71 * texel.g + 0.07 * texel.b;
            return gray;
        }

        //Has a bug, creates long vertical lines, needs to fix
        //vec4 gaussian_blur(vec2 uv) {
        //    vec4 result = vec4(0.0);
        //    for (int i = 0; i < 7; i++) {
        //        vec2 current_uv = vec2(uv.x + gauss_filter[i].x*(1.0/resolution.x), uv.y);

        //        float current_gray = gray(current_uv);

        //        current_uv = vec2(uv.x + gauss_filter[i].x, uv.y*(1.0/resolution.y));

        //        current_gray = sqrt(pow(gray(current_uv), 2.0) + pow(current_gray, 2.0));

        //        result += current_gray*gauss_filter[i].y;
        //    }

        //    return result;
        //}

        vec4 sobel_edge(vec2 uv) {
            float w = 1.0 / resolution.x;
            float h = 1.0 / resolution.y;
            vec4 n[9];

            //if (isWithGaussianBlur != 0.0) {
            //    n[0] = gaussian_blur(uv + vec2( -w, -h));
            //    n[1] = gaussian_blur(uv + vec2(0.0, -h));
            //    n[2] = gaussian_blur(uv + vec2(  w, -h));
            //    n[3] = gaussian_blur(uv + vec2( -w, 0.0));
            //    n[4] = gaussian_blur(uv);
            //    n[5] = gaussian_blur(uv + vec2(  w, 0.0));
            //    n[6] = gaussian_blur(uv + vec2( -w, h));
            //    n[7] = gaussian_blur(uv + vec2(0.0, h));
            //    n[8] = gaussian_blur(uv + vec2(  w, h));
            //} else {
                n[0] = vec4(gray(uv + vec2( -w, -h)));
                n[1] = vec4(gray(uv + vec2(0.0, -h)));
                n[2] = vec4(gray(uv + vec2(  w, -h)));
                n[3] = vec4(gray(uv + vec2( -w, 0.0)));
                n[4] = vec4(gray(uv));
                n[5] = vec4(gray(uv + vec2(  w, 0.0)));
                n[6] = vec4(gray(uv + vec2( -w, h)));
                n[7] = vec4(gray(uv + vec2(0.0, h)));
                n[8] = vec4(gray(uv + vec2(  w, h)));
            //}

            vec4 sobel_edge_h = n[2] + (2.0*n[5]) + n[8] - (n[0] + (2.0*n[3]) + n[6]);
            vec4 sobel_edge_v = n[0] + (2.0*n[1]) + n[2] - (n[6] + (2.0*n[7]) + n[8]);
            vec4 sobel = sqrt((sobel_edge_h * sobel_edge_h) + (sobel_edge_v * sobel_edge_v));
            
            return sobel;
        }

        void main() {
            vec4 texel = texture2D(tDiffuse, vUv);
            //float g = gray(vUv);
            //gl_FragColor = vec4(texel.rgb * (1.0 - colorFactor) + (gray * colorFactor), texel.a);

            gl_FragColor = texel;
            //gl_FragColor = vec4(vec3(gray(vUv)), texel.a);
            //gl_FragColor = gaussian_blur(vUv);
            //return;
            vec4 s = sobel_edge(vUv);
            if (s.a > edgeThreshold) {
                gl_FragColor = vec4(edgeColor*sobel_edge(vUv).xyz, texel.a);
            }

            //if (isWithGaussianBlur != 0.0) {
            //    gl_FragColor = gaussian_blur(vUv);
            //} else {
            //    gl_FragColor = vec4(vec3(gray(vUv)), texel.a);
            //}
        }
    `,

};

export { SobelEdgeShader };

